import { useMemo } from 'react';
import { useParams } from 'react-router';
import {
  DEFAULT_NEW_STUDIO_CATEGORY_SLUG,
  DEFAULT_STUDIO_CATEGORY_SLUG,
} from '../config';
import { useExperiments } from '../contexts/ExperimentsContext';

export function useParamsWithDefaults() {
  const { is } = useExperiments();
  const isNewStudioTP = is('specs.funnel.StudioTemplatesPageNewUI', 'true');

  const params = useParams();
  return useMemo(
    () => ({
      categorySlug: isNewStudioTP
        ? DEFAULT_NEW_STUDIO_CATEGORY_SLUG
        : DEFAULT_STUDIO_CATEGORY_SLUG,
      ...params,
    }),
    [params, isNewStudioTP],
  );
}
